export const AUTH0_AUDIENCES = {
    MAKMATE: "Makmate",
    WEBMSI: "WebMSI"
};
const apiAudience = [AUTH0_AUDIENCES.MAKMATE, AUTH0_AUDIENCES.WEBMSI] as const;
export type APIAudience = typeof apiAudience[number];
